import React from 'react';
import { Box, Container, Grid } from '@mui/material';

// @desc Content Wrapper for better alignment of components
const ContentWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        paddingTop: '70px',
        minHeight: 'calc(100vh - 70px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Container maxWidth='xxl' style={{ height: '100%' }}>
        <Grid container spacing={2} style={{ minHeight: '100%' }}>
          {children}
        </Grid>
      </Container>
    </Box>
  );
};

export default ContentWrapper;
